import { ApiBase } from "../internal";

export class ApprovalApi extends ApiBase {
  /*constructor() {
    super();
  }*/


  async saveApproval(ApprovalData) {
    const { PlanId, ...Approval } = ApprovalData;
    const requestBody = { PlanId, Approval };
    const response = await this.httpClient.post("/combinedplan/saveapproval", requestBody,
      {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": sessionStorage.getItem('language') === "en" ? "en-US" : sessionStorage.getItem('language')
        }
      });
    return response;
  }
}